<template>
  <div id="redirectLogin">
    <div class="imgBgSSO">
      <div class="loginSSo">
        <div>
          登录中...
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'redirectLogin',
  data () { // 所有的数据都写在里面
    return {
      gskToken: localStorage.gskToken || '',
      queryCode: this.$route.query.code || ''
    }
  },
  created () {
    this.goUrl()
  },
  methods: {// 所有的方法写在里面
    GetRoleMenu () {
      this.$axiox.get('/api/Role/GetRoleMenu').then(msg => {
        let userMenu = msg.data || []
        if (userMenu) {
          let list = []
          let pathList = []
          for (let i = 0; i < userMenu.length; i++) {
            list.push(userMenu[i].name)
            pathList.push(userMenu[i].path)
            for (let j = 0; j < userMenu[i].child.length; j++) {
              list = list.concat(userMenu[i].child[j].cName)
            }
          }

          Vue.prototype.$userMenu = list
          Vue.prototype.$pathList = pathList
          // this.$router.push({
          //   name: 'myHome'
          // })
          this.$router.push({
            name: pathList[0] || 'myHome'
          })
        }
      })
    },
    goUrl () {
      localStorage.gskToken = ''
      localStorage.gskloginInfo = {}
      //if (!this.gskToken) {
        this.$axiox.get('/saml/mocklogin?email=' + this.queryCode).then(msg => {
          let newToken = msg.data.jwtToken || ''
          let gskloginInfo = msg.data || {}
          if (newToken) {
            localStorage.gskToken = newToken
            localStorage.gskloginInfo = JSON.stringify(gskloginInfo)
            this.GetRoleMenu()
          }
        })
      //} else {
      //  this.$router.push({
      //    name: 'myHome'
      //  })
      //}
      // window.location.reload()
    }
  }
}
</script>

<style scoped>
.imgBgSSO {
  display: flex;
  align-items: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.loginSSo {
  margin-left: 46%;
  min-width: 300px;
  z-index: 2;
  background: #fff;
  padding: 20px;
  font-size: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/login/thirdlogin.vue